<template>
  <div class="card card-bordered w-[19rem] bg-white p-4 border-neutral-200 self-end" :class="'product-' + product.id">
    <div class="flex flex-row justify-between">
      <ProductBadge
          :created-at="product.created_at"
          :price-vat="product.price_vat"
          :price-default-vat="product.price_default_vat"
          :discount-start="product.discount_start"
          :discount-end="product.discount_end"
          :banners="product.banners"
          :campaign-label="product.campaign_label"
          :good-price="product.good_price"
      />
      <ProductLogo :brand="product.brand"/>
    </div>
    <Link
        :href="trRoute('product', { product: trField(product, 'url') })"
        class="m-4 swap h-52"
        :class="{
        'swap-active': hover
      }"
        @mouseover="hover = true"
        @mouseleave="hover = false"
    >
      <div class="swap-off w-52 h-52">
        <ProductPicture
            :image="product.filename"
            :title="product.title"
            classes="w-48 h-48"
            size="235"
        />
      </div>
      <div class="swap-on overflow-hidden w-52 h-52">
        <ProductDetails classes="table-xs" :details="product.details"/>
      </div>
    </Link>
    <Link
        class="text-left text-lg text-primary-500 leading-6 h-[4.4rem] font-semibold line-clamp-3 mb-4"
        :href="trRoute('product', { product: trField(product, 'url') })"
    >
      {{ trField(product, "title") }}
    </Link>
    <div class="flex flex-row justify-between mb-2">
      <div class="text-left text-primary-500 text-sm">
        {{ product.code }}
      </div>
      <ProductShipping
          :stocklevel="product.stocklevel"
          :interim-stocklevel="product.interim_stocklevel"
          :shipping-time="product.shipping_time"
      />
    </div>
    <div class="flex flex-row justify-between mb-4 h-12">
      <ProductPrice
          :price-vat="product.price_vat"
          :price-default-vat="product.price_default_vat"
          :discount-start="product.discount_start"
          :discount-end="product.discount_end"
          :good-price="product.good_price"
      />
      <EnergyLabel v-if="product.energy_class" :product-class="product.class" :energy-class="product.energy_class"/>
    </div>
    <div class="flex flex-row justify-between">
      <Link
          class="btn btn-outline btn-primary text-lg font-semibold h-10 min-h-[2.5rem]"
          :href="trRoute('product', { product: trField(product, 'url') })"
      >
        {{ __("Vaata") }}
      </Link>
      <a
          href="#"
          class="add-to-cart btn btn-info text-lg text-white font-semibold h-10 min-h-[2.5rem]"
          @click.prevent="addToCart"
      >
        {{ __("Lisa ostukorvi") }}
      </a>
    </div>
    <a
        v-if="compare"
        :data-tooltip="__('Lisa võrdlusse')"
        href="#"
        class="text-base text-primary-500 font-semibold add-to-compare mt-4"
        @click.prevent="addToCompare"
    >
      <CompareSvg class="w-4 h-4 inline-block mr-2"/>
      {{ __("Lisa võrdlusse") }}
    </a>
  </div>
</template>

<script setup>
import {__, toCart, trField, trRoute} from "../utils";
import ProductBadge from "../components/ProductBadge.vue";
import ProductPicture from "../components/ProductPicture.vue";
import ProductShipping from "../components/ProductShipping.vue";
import ProductPrice from "../components/ProductPrice.vue";
import {Link, router} from "@inertiajs/vue3";
import EnergyLabel from "../components/EnergyLabel.vue";
import ProductLogo from "../components/ProductLogo.vue";
import ProductDetails from "../components/ProductDetails.vue";
import {ref} from "vue";
import CompareSvg from "../../images/elux-vordlus.svg";

const props = defineProps({
  product: Object,
  compare: {
    default: true,
    type: Boolean
  }
});
const hover = ref(false);
const addToCart = () => toCart({id: props.product.id, show_modal: true});
const addToCompare = () =>
    router.put(trRoute("compare.update", {id: props.product.id}), null, {
      preserveScroll: true
    });
</script>
